import { inject, Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { catchError, Observable } from 'rxjs';
import { DepartmentService } from '@doc/api/server-bo';

@Injectable({
  providedIn: 'root'
})
export class SbuResolver implements Resolve<any> {

  
  private departmentService = inject(DepartmentService);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.departmentService.getCategoryList({}).pipe(
      catchError(error => {
        return [];
      })
    )
  }
}
